/**
 * Compatibility export for server consumers. The edit-protocol constants are
 * owned by core's dependency-free browser contract.
 */
export * from "@hyperframes/core/editing/draft-markers";
